<google-chart [options]="options" [type]="type" [data]="data" [dynamicResize]="true"></google-chart>